export const getCleanDomain = (): string => {
  const domain = window.location.hostname
  const cleanDomain = domain.replace(/^(web\.|www\.|dev\.)+/, '')
  if (cleanDomain.includes('localhost')) {
    return 'default'
  }

  return cleanDomain
}
